import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { ModalShell } from '../ui/shell';
import { Btn } from '../ui/primitives';
import TrainingSettingForm from './TrainingSettingForm';

/**
 * Per-row training settings modal — wraps the shared settings form without duplicating logic.
 */
const TrainingSettingDialog = ({
  open,
  trainingDetails,
  onClose,
  onSaved,
  saveLocked = false,
  onSaveBlocked,
}) => {
  const [actionState, setActionState] = useState({ isLoading: false });

  if (!open || !trainingDetails) return null;

  const trainingName = trainingDetails.trainingName || 'Training';
  const formId = 'training-settings-form';

  const handleSaveClick = (event) => {
    if (!saveLocked) return;
    event.preventDefault();
    if (onSaveBlocked) onSaveBlocked();
  };

  return (
    <ModalShell
      title="Training settings"
      sub={trainingName}
      onClose={onClose}
      max="680px"
      foot={(
        <>
          <Btn type="button" $variant="ghost" onClick={onClose} disabled={actionState.isLoading}>
            Cancel
          </Btn>
          <Btn
            type={saveLocked ? 'button' : 'submit'}
            form={saveLocked ? undefined : formId}
            $variant={saveLocked ? 'ghost' : 'subtle'}
            disabled={actionState.isLoading}
            onClick={handleSaveClick}
          >
            {saveLocked ? <Lock size={15} strokeWidth={2} aria-hidden="true" /> : null}
            {actionState.isLoading ? 'Saving…' : 'Save changes'}
          </Btn>
        </>
      )}
    >
      <TrainingSettingForm
        key={trainingDetails.trainingId}
        trainingDetails={trainingDetails}
        onDismiss={onClose}
        onSaved={onSaved}
        formId={formId}
        onActionStateChange={setActionState}
        showInlineFooter={false}
        saveDisabled={saveLocked}
      />
    </ModalShell>
  );
};

export default TrainingSettingDialog;
